// extracted by mini-css-extract-plugin
module.exports = {"spinner":"Router_spinner__2hHu4"};